module.exports = __webpack_public_path__ + "img/H-63-ER-1500-BB.6e10c78e.png";